import { Grid, GridColumn, TGridColumnWidth, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import LoginButton from '../components/LoginButton';
import { runInTeliaRumService } from '../util/TeliaOtelUtil';
import RememberMe from './RememberMe';
import useStores from '../stores/UseStores';
import { shouldFixModuleRendering } from '../util/ModuleUtil';

const IdCardLogin = observer((): JSX.Element => {
  const {
    idCardLoginStore,
    translateStore: { translate },
    uiStore: { componentWidth }
  } = useStores();

  const login = (event: React.FormEvent) => {
    runInTeliaRumService('Autentimine (ID-kaart)', () => {
      event.preventDefault();
      idCardLoginStore.handleLogin();
    });
  };

  const gridWidth: TGridColumnWidth[] = ['sm-8', 'md-6', `lg-${shouldFixModuleRendering(componentWidth) ? '10' : '4'}`];

  return (
    <form onSubmit={(event) => login(event)}>
      <Text>
        <Grid align={['center-sm']}>
          <GridColumn width={gridWidth}>
            <Text>
              {translate('panel.id.title')}
              <RememberMe tabItemId="idCardLoginTab" />
              <LoginButton isLoading={idCardLoginStore.submitting} disabled={idCardLoginStore.submitting} />
            </Text>
          </GridColumn>
        </Grid>
      </Text>
    </form>
  );
});

export default IdCardLogin;
